class Wallet {
    constructor(connectionManager) {
        window.tokenThreshold = 10000;
        window.tokensUpdated = 0;
        connectionManager.addHandler(msg => {
            const data = app.util.jsonDecode(msg.querySelector("body").innerHTML);
            if (data && data[app.config.user.id]) {
                let globalCounter = document.getElementById("tokens-count");
                if (globalCounter) {
                    app.config.tokens = data[app.config.user.id].t;
                    app.util.counter(globalCounter, data[app.config.user.id].t, 1000);
                    return true;
                } else {
                    let gameCounter = null;
                    for (let s in data[app.config.user.id].sd) {
                        if (data[app.config.user.id].sd[s] !== "global") {
                            gameCounter = document.getElementById("tokens-" + s);
                            if (gameCounter) {
                                app.util.counter(gameCounter, data[app.config.user.id].sd[s], 1000, true);
                                if (!app.config.user.v) {
                                    window.tokensUpdated += data[app.config.user.id].sd[s];
                                    if (window.tokensUpdated > window.tokenThreshold) {
                                        window.tokensUpdated = 0;
                                        app.analytics.insertOverlayAd();
                                    }
                                }
                                return true;
                            }
                        }
                    }
                }
            }

            return true;
        }, 'cego:xmpp:tokens-update:system');
    }

    getTokens() {
        return app.config.tokens;
    }

    adjustTokens(newValue) {
        app.config.tokens = newValue;
        app.util.counter("tokens-count", newValue, 1000, false, 0);
    }
}
